import { i18nGlobalService } from '@inpart-io/devtools-vue';

export class I18nService {
    public t(key: string, named?: Record<string, unknown>): string {
        return i18nGlobalService.t(key, named);
    }
}

export const i18nService = new I18nService();
